import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useRef, useState } from 'react';
export var useAutoplay = function useAutoplay(_ref, setIsTouchActive) {
  var autoplay = _ref.autoplay;
  var sliderRef = useRef();
  var timeout = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mouseOver = _useState2[0],
    setMouseOver = _useState2[1];
  var clearNextTimeout = useCallback(function () {
    return clearTimeout(timeout.current);
  }, []);
  var nextTimeout = useCallback(function () {
    clearNextTimeout();
    if (!mouseOver) {
      timeout.current = setTimeout(function () {
        var _sliderRef$current;
        return (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 ? void 0 : _sliderRef$current.next();
      }, autoplay === null || autoplay === void 0 ? void 0 : autoplay.interval);
    }
  }, [autoplay === null || autoplay === void 0 ? void 0 : autoplay.interval, clearNextTimeout, mouseOver]);
  var onMouseOver = useCallback(function () {
    setMouseOver(true);
    clearNextTimeout();
  }, [clearNextTimeout]);
  var onMouseOut = useCallback(function () {
    setMouseOver(false);
    nextTimeout();
  }, [nextTimeout]);
  var onTouchStart = useCallback(function () {
    setIsTouchActive(true);
    setMouseOver(true);
    clearNextTimeout();
  }, [clearNextTimeout, setIsTouchActive]);
  var onTouchEnd = useCallback(function () {
    setIsTouchActive(false);
    setMouseOver(false);
    nextTimeout();
  }, [nextTimeout, setIsTouchActive]);
  var plugin = useCallback(function (slider) {
    sliderRef.current = slider;
    sliderRef.current.on('created', function (instance) {
      var parent = instance.container.parentElement;
      parent === null || parent === void 0 || parent.addEventListener('mouseover', onMouseOver);
      parent === null || parent === void 0 || parent.addEventListener('touchstart', onTouchStart);
      parent === null || parent === void 0 || parent.addEventListener('mouseout', onMouseOut);
      parent === null || parent === void 0 || parent.addEventListener('touchend', onTouchEnd);
      nextTimeout();
    });
    sliderRef.current.on('animationEnded', nextTimeout);
    sliderRef.current.on('destroyed', function (instance) {
      var parent = instance.container.parentElement;
      parent === null || parent === void 0 || parent.removeEventListener('mouseover', onMouseOver);
      parent === null || parent === void 0 || parent.removeEventListener('touchstart', onTouchStart);
      parent === null || parent === void 0 || parent.removeEventListener('mouseout', onMouseOut);
      parent === null || parent === void 0 || parent.removeEventListener('touchend', onTouchEnd);
      sliderRef.current = undefined;
    });
  }, [nextTimeout, onMouseOut, onMouseOver, onTouchEnd, onTouchStart]);
  return autoplay !== null && autoplay !== void 0 && autoplay.enabled ? plugin : undefined;
};
//# sourceMappingURL=useAutoplay.js.map